// extracted by mini-css-extract-plugin
export default {"mailDiscussArea":"mailDiscuss-module--mailDiscussArea--8fgTX","discussIcon":"mailDiscuss-module--discussIcon--BsbIj"};